import { render, staticRenderFns } from "./OlCard.vue?vue&type=template&id=5459bf14&scoped=true"
var script = {}
import style0 from "./OlCard.vue?vue&type=style&index=0&id=5459bf14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459bf14",
  null
  
)

export default component.exports